export default __webpack_public_path__ + "static/media/117.c4b52731.jpeg";